import { urls } from "@selector/shared";
import { TrackEnum } from "@selector/shared/openapi";
import { useCallback } from "react";
import { Icons, TriggerButton } from "widgets";

import { useGenomeViewerStore } from "../../../store/store.ts";
import { routeWithBasename } from "../../../utils/route-with-basename.ts";
import { getEntityTypeFromTrackType } from "../../../utils/type-conversion.ts";

export const OpenGenomeViewerButton = ({ id, trackId }: { id: number; trackId: string }) => {
  const trackType = useGenomeViewerStore((state) => state.tracks.get(trackId)?.trackType);

  const handleClick = useCallback(() => {
    if (!trackType) return;
    const type = getEntityTypeFromTrackType(trackType);
    window.open(routeWithBasename(`/${type}/${id}/genome`, urls), "_blank");
  }, [id, trackType]);

  return (
    <TriggerButton
      icon={<img src={Icons.Action.GenomeViewer} width={20} height={20} alt="Genome Viewer" />}
      onPress={handleClick}
      label={"Open in Genome Viewer"}
      isDisabled={trackType === TrackEnum.SEQUENCE}
    />
  );
};
